import type { Manager } from '@ludus/core'

/** A row seeded before names were required may carry none; the source's word for the person stands in. */
export function fullName(manager: Manager): string {
  const name = [manager.firstName, manager.lastName].filter(Boolean).join(' ')
  if (name) return name
  const identity = manager.identities[0]
  return identity?.displayName ?? identity?.externalRef ?? manager.id
}

export function initialsOf(manager: Manager): string {
  return fullName(manager)
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase()
}
